import firebase from 'firebase/app';
import { InstructorData } from './instructorData';
import { userValidationSchema } from './userValidationSchema';

export function validateInstructorInfo(
  instructorData: InstructorData | undefined,
  firebaseUser: firebase.User
): boolean {
  // Sync validation is probably alright here since the object is small
  return userValidationSchema.isValidSync(instructorData) && !!firebaseUser.photoURL;
}
